<template>
  <div class="app-container-v2 table-container-v2" :class="{ 'has-footer-bar': edit }">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">邮件模板设置</span>
      </div>
      <div class="title-right">
        <el-button type="primary" class="button-v2" @click="edit=true">编辑</el-button>
      </div>
    </div>
    <div class="table-body flex vertical">
      <el-form class="form-v2" ref="form" :model="formInline" label-width="92px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="邮件主题" prop="emailTheme">
              <el-input
                id="emailTheme"
                v-model="formInline.emailTitle"
                type="text"
                placeholder="请输入邮件主题"
                maxlength="201"
                :readonly="!edit"
                @focus="clickEmTem">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="邮件内容" prop="emailContent">
              <el-input
                v-model="formInline.emailContent"
                type="textarea"
                show-word-limit
                placeholder="请输入邮件内容"
                :readonly="!edit"
                :rows="8"
                @focus="clickEmCon" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item>
              <el-button class="payrollBut" type="warning" plain v-for="item in buttonList" :key="item.keys" @click="fullContent(item)" size="medium">{{item.name}}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <air-footer-bar v-if="edit">
      <el-button class="button-v2" plain @click="cancel">取消</el-button>
      <el-button class="button-v2" type="primary" @click="setTing">确认</el-button>
    </air-footer-bar>
  </div>
</template>
<script>
import {
    setEmail
} from "@/api/tesla/emailSetting.js";

export default {
    data() {
        return {
            buttonList: [
                {name: '雇员编号', keys: 'empName'},
                {name: '雇员姓名', keys: 'cusName'},
                {name: '雇员证件号', keys: 'empDept'},
                {name: '雇员邮箱账号', keys: 'empIdCard'},
                {name: '还款金额', keys: 'empCardLastSix'},
                {name: '还款时间', keys: 'url'},
                {name: '公司开户名', keys: 'shifa'},
                {name: '雇员编号', keys: 'empName'},
                {name: '雇员姓名', keys: 'cusName'},
                {name: '雇员证件号', keys: 'empDept'},
                {name: '雇员邮箱账号', keys: 'empIdCard'},
                {name: '还款金额', keys: 'empCardLastSix'},
                {name: '还款时间', keys: 'url'},
                {name: '公司开户名', keys: 'shifa'},
            ],
            formInline:{
                emailContent:`尊敬的<雇员姓名>先生/女士：
                您于<季度>的股票归权发生的个人所得税需向公司还款金额，即从工资中扣除之后的剩余待还款个人所得税金额为<还款金额>。
                请您务必<还款时间>前还款到指定公司账户，并填写付款摘要以供后续核对，感谢您的支持和配合。
                公司开户名：<公司开户名>
                公司银行账号：<公司银行账号>
                公司开户行：<公司开户行>
                汇款摘要：<汇款摘要>`,
                emailTitle:'邮件主题'
            },
            rules: {
                emailTheme: [
                    { required: true, message: '请输入邮件主题', trigger: 'blur' },
                    { max: 200, message: "长度在200 个字符以内", trigger: "blur" },
                ],
                emailContent: [
                    { required: true, message: '请输入邮件内容', trigger: 'blur' },
                ]
            },
            guang:'',
            edit:false
        };
    },
    methods:{
        clickEmTem(event) {
            this.guang = 'emailTheme';
        },
        clickEmCon(event) {
            this.guang = 'emailContent';
        },
        fullContent(val) {
            if(this.edit){
                this.insertInputTxt('emailContent','<' + val.name + '>');
            }
        },
        insertInputTxt(id, insertTxt) {
            let elInput = document.getElementById(id);
            let startPos = elInput.selectionStart;
            let endPos = elInput.selectionEnd;
            if (startPos === undefined || endPos === undefined) return
            let txt = elInput.value;
            let result = txt.substring(0, startPos) + insertTxt + txt.substring(endPos)
            elInput.value = result;
            elInput.focus();
            elInput.selectionStart = startPos + insertTxt.length;
            elInput.selectionEnd = startPos + insertTxt.length;
            return elInput.value;
        },
        // 保存
        setTing () {
            this.formInline.emailContent= this.insertInputTxt('emailContent','<' + val.name + '>');
            setEmail(this.formInline).then(res=> {

            })
        },
        // 取消
        cancel() {
            this.edit =false;
            document.getElementById('emailContent').value= `尊敬的<雇员姓名>先生/女士：
                您于<季度>的股票归权发生的个人所得税需向公司还款金额，即从工资中扣除之后的剩余待还款个人所得税金额为<还款金额>。
                请您务必<还款时间>前还款到指定公司账户，并填写付款摘要以供后续核对，感谢您的支持和配合。
                公司开户名：<公司开户名>
                公司银行账号：<公司银行账号>
                公司开户行：<公司开户行>
                汇款摘要：<汇款摘要>`
        }
       
    }
}
</script>
<style lang="scss" scoped>
  .payrollBut {
      margin-left: 0;
      margin-right: 5px;
      color: rgb(230, 162, 60) !important;
      background: #fdf6ec !important;
      border-color: rgb(245, 218, 177) !important
  }
</style>
